export default __webpack_public_path__ + "static/media/not-found.f890dc19.svg";